module.exports = __webpack_public_path__ + "img/solidproof.95a8c477.png";